export var REQUEST_SIGN_OUT = 'REQUEST_SIGN_OUT';
export var COMPLETE_SIGN_OUT = 'COMPLETE_SIGN_OUT';